import _ from 'lodash';
import {fromJS} from 'immutable';
import * as Cookies from 'js-cookie';

import * as actions from './actions';


export default function reducer(
    state = fromJS({
        elementId: window.uuidv4(),
        errors: {},
        items: Cookies.getJSON('mhelli-cart') || {},
        info: {},
        'delivery_method': null,
        'payment_method': null,
    }),
    action,
) {
    switch (action.type) {
    case actions.CLEAR:
        state = state.set('items', state.get('items').filter(item => item.getIn(['item', 'virtual']) !== action.itemType));
        break;

    case actions.ADD:
        if (state.get('items').get(String(action.payload.item.id))) {
            state = state.setIn(
                ['items', String(action.payload.item.id), 'count'],
                state.getIn(['items', String(action.payload.item.id), 'item', 'virtual'])
                    ? 1
                    : state.getIn(['items', String(action.payload.item.id), 'count']) + action.payload.count,
            );
            state = state.setIn(
                ['items', String(action.payload.item.id), 'editTimestamp'],
                Date.now(),
            );
        }
        else
            state = state.setIn(['items', String(action.payload.item.id)], fromJS({
                ...action.payload,
                count: action.payload.item.virtual ? 1 : action.payload.count,
                timestamp: Date.now(),
                editTimestamp: Date.now(),
            }));
        break;

    case actions.REMOVE:
        state = state.deleteIn(['items', String(action.item.id)]);
        break;

    case actions.SET_COUNT:
        state = state.setIn(['items', String(action.item.id), 'count'], action.value);
        break;

    case actions.LOCK:
        state = state.set('locked', true);
        break;

    case actions.UNLOCK:
        state = state.set('locked', false);
        break;

    case actions.SET_INFO:
        if (state.getIn(['info', 'address']) !== action.payload.address)
            state = state.set('delivery_method', null);
        state = state.set('info', fromJS(action.payload));
        break;

    case actions.SET_DELIVERY_METHOD:
        state = state.set('delivery_method', action.payload);
        break;

    case actions.SET_PAYMENT_METHOD:
        state = state.set('payment_method', action.payload);
        break;
    }
    if (!_.isEqual(state.get('items').toJS(), Cookies.get('mhelli-cart'))) {
        Cookies.set('mhelli-cart', state.get('items').toJS(), {expires: 365});
    }
    return state;
}
